<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 48 48">
    <title>{{title}}</title>
    <path :fill="fill" d="M42 12h-4v18H12v4c0 1.1.9 2 2 2h22l8 8V14c0-1.1-.9-2-2-2zm-8 12V6c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v28l8-8h20c1.1 0 2-.9 2-2z"></path>
  </svg>
</template>

<script>
export default {
  name: "QuestionAnswer",
  props: {
    title: {
      default: 'Répondre',
      type: String,
    },
    fill: {
      default: 'currentColor',
      type: String,
    },
    size: {
      type: Number,
      default: 18,
    },
  },
}
</script>
